<script>
  import { fade } from 'svelte/transition'
  import { scaleLinear, scaleTime } from 'd3-scale'
  import { max, extent } from 'd3-array'
  import { getContext } from 'svelte'

  import { formatThousands, formatDateLong, formatDateShort } from './functions'

  import { onMount } from 'svelte'
  import Axis from './components/Axis.svelte'
  import AxisRight from './components/AxisRight.svelte'
  import Line from './components/Line.svelte'
  import Area from './components/Area.svelte'
  import { colors } from './colors.js'
  import Grid from './components/Grid.svelte'

  let { nData, cData, margin } = getContext('chart')
  let nationalData = nData()
  let incomingData = cData()

  incomingData.forEach((d) => {
    d.casesSevenDays = +d['7_day_weekly_average']
    d.vaccinationsSevenDays = +d['vaccinations_7_day_average']
    d.casesDaily = +d['cases_daily']
  })
  console.log(incomingData)

  let width
  let height = 300
  let latestVaccCount
  let latestDate
  let days = 180
  let defaultBarColor
  let xScale, yScale
  let xTicks, yTicks

  $: cumulativeData = incomingData.filter(
    (d, i) => i > incomingData.length - days
  )

  $: xScale = scaleTime()
    .range([margin.left, width - 20])
    .domain(extent(cumulativeData, (d) => d.date))

  $: yScale = scaleLinear()
    .range([height - margin.bottom, margin.top])
    .domain([0, max(cumulativeData, (d) => d.casesDaily)])

  $: yScale2 = scaleLinear()
    .range([height - margin.bottom, margin.top])
    .domain([0, max(cumulativeData, (d) => d.vaccinationsSevenDays)])

  $: xTicks = xScale.ticks(5)
  $: yTicks = yScale.ticks(5)
  $: yTicks2 = yScale2.ticks(5)
</script>

<div class="chart-wrap">
  <div class="chart-title">Daily Cases & 7-day average</div>
  <div class="chart-description">
    <span style="color: {colors['red700']}; font-weight: 700;"
      >7-Day Average New Cases</span
    >
    <br />Updated: {formatDateLong(
      cumulativeData[cumulativeData.length - 1].date
    )}
  </div>
  <div class="options">
    <div
      class="option-box {days === 720 ? 'option-selected' : ''}"
      on:click={() => {
        days = 720
      }}
    >
      2 years
    </div>
    <div
      class="option-box {days === 365 ? 'option-selected' : ''}"
      on:click={() => {
        days = 365
      }}
    >
      1 year
    </div>
    <div
      class="option-box {days === 180 ? 'option-selected' : ''}"
      on:click={() => {
        days = 180
      }}
    >
      180 days
    </div>
    <div
      class="option-box {days === 90 ? 'option-selected' : ''}"
      on:click={() => {
        days = 90
      }}
    >
      90 days
    </div>
    <div
      class="option-box {days === 60 ? 'option-selected' : ''}"
      on:click={() => {
        days = 60
      }}
    >
      60 days
    </div>
    <div
      class="option-box {days === 30 ? 'option-selected' : ''}"
      on:click={() => {
        days = 30
      }}
    >
      30 days
    </div>
  </div>
  <div
    class="chart chart-vax-cases chart-block"
    bind:clientWidth={width}
    transition:fade
  >
    <div class="tooltip">Tooltip</div>
    <div class="latest-data">
      <div class="latest-number">{formatThousands(latestVaccCount)}</div>
      <div class="latest-date">{formatDateLong(latestDate)}</div>
    </div>
    <svg {width} {height}>
      <Grid
        type="y"
        ticks={{ x: xTicks, y: yTicks }}
        scale={{ x: xScale, y: yScale }}
        {height}
        {width}
      />

      <Axis
        type="y"
        {height}
        {width}
        scale={{ x: xScale, y: yScale }}
        ticks={{ x: xTicks, y: yTicks }}
      />
      <Axis
        type="x"
        {height}
        {width}
        scale={{ x: xScale, y: yScale }}
        ticks={{ x: xTicks, y: yTicks }}
      />

      <!-- <Area
        scale={{ x: xScale, y: yScale2 }}
        values={{ x: 'date', y: 'vaccinationsSevenDays' }}
        {height}
        {width}
        data={cumulativeData}
        fill={colors['lightgray']}
      /> -->

      {#each cumulativeData as cases}
        <rect
          x={xScale(cases.date)}
          y={yScale(cases.casesDaily)}
          width="3"
          height={yScale(0) - yScale(cases.casesDaily)}
          fill="gray"
        />
      {/each}

      <Line
        {height}
        {width}
        stroke={colors['red700']}
        strokeWidth="3"
        scale={{ x: xScale, y: yScale }}
        data={cumulativeData}
        values={{ x: 'date', y: 'casesSevenDays' }}
      />

      <!-- <Line
        {height}
        {width}
        stroke={'lightgray'}
        strokeWidth="1"
        scale={{ x: xScale, y: yScale2 }}
        data={cumulativeData}
        values={{ x: 'date', y: 'vaccinationsSevenDays' }}
      /> -->

      <!-- <AxisRight
        type="y"
        {height}
        {width}
        scale={{ x: xScale, y: yScale2 }}
        ticks={{ x: xTicks, y: yTicks2 }}
        textColor={colors['green700']}
      /> -->
    </svg>
  </div>
</div>

<style>
  .options {
    font-family: 'Robotp', Arial, Helvetica, sans-serif;
    /* width: 100%; */
    /* display: grid;
    grid-template-columns: repeat(6, auto);
    grid-gap: 2px; */
    font-size: 0.7rem;
  }
  .options * {
    display: inline-block;
  }
  .option-box {
    border: none;
    padding: 3px 7px;
    border: none;
    text-transform: uppercase;
    background: #eee;
    color: #000;
    font-weight: 700;
    cursor: pointer;
  }
  .option-selected {
    background: indianred;
    color: #fff;
  }
  .chart {
    position: relative;
    font-family: 'Titillium Web', Arial, Helvetica, sans-serif;
    width: 100%;

    min-height: 250px;
    margin: 0 auto;
  }

  .latest-data {
    position: absolute;
    top: 20px;
    left: 20px;
    line-height: 100%;
    left: -10000px;
  }
  .latest-number {
    background: var(--darkgreen);
    color: #fff;
    padding: 4px 6px;
    font-size: 80%;
    border-radius: 5px;
  }
  .latest-date {
    font-size: 70%;
    margin-top: 2px;
    margin-bottom: 3px;
  }
</style>
